<script lang="ts">
  import type { Spot, ContentApiResponse } from "$lib/elev8Api/contentTypes";
  import ContentRenderer from "$lib/content/ContentRenderer.svelte";
  import WeatherContent from "$lib/content/components/WeatherContent.svelte";
  import LayoutSelector from "$lib/layouts/LayoutSelector.svelte";
  import LayoutTheme from "$lib/layouts/LayoutTheme.svelte";
  import { fade } from "svelte/transition";

  interface Props {
    spotIndex: number;
    spots: Spot[];
    ticker?: ContentApiResponse["ticker"];
    [key: string]: unknown;
  }
  let { spotIndex, spots, ticker, ...restProps }: Props = $props();
  let spot = $derived(spots[spotIndex]);
  let weather = $derived(ticker?.find((t) => t.content_type === "weather"));
  let initialRenderTransition = (node: Element) => fade(node);
  //  primary(1), secondary(2), tertiary(3), quaternary(4), quinary(5), senary(6), septenary(7), octonary(8), nonary(9), denary(10).'
  // LayoutSelector alternate approach - just pass the spot or spot.contents array,
  // then it can call ContentRenderer in a #for loop.
  // Make the contents a simple flex box layout that can take any number of contents, with a csszengarden style layout.
</script>

<LayoutTheme>
  <div
    class="h-full w-full bg-white"
    id="spot-renderer"
    transition:initialRenderTransition
  >
    <LayoutSelector layout={spot?.layout}>
      {#snippet ContentMain()}
        <ContentRenderer content={spot?.contents[0]} {...restProps} />
      {/snippet}
      {#snippet ContentSecondary()}
        <ContentRenderer content={spot?.contents[1]} {...restProps} />
      {/snippet}
      {#snippet ContentTertiary()}
        <ContentRenderer content={spot?.contents[2]} {...restProps} />
      {/snippet}
      {#snippet ContentWeather()}
        <WeatherContent {weather} />
      {/snippet}
    </LayoutSelector>
  </div>
</LayoutTheme>
